import React from 'react'
import PropTypes from 'prop-types'

import { useGetQuery } from '../../lib/api/get'
import { useGetMutateCall } from '../../lib/api/get'
import { NoDataCard } from '../../common/NoDataCard'
import { ChildForm } from '../basicForm/ChildForm'

export const ClassPromotions = ({ isLocalEnvironment, envData, routeData }) => {
  var curr = new Date()
  curr.setDate(curr.getDate())
  const modalSchema = JSON.parse(routeData.apiEndPointSchema).modalRowForm[0]
  const getCallMutation = useGetMutateCall()
  const [roomVal, setRoomVal] = React.useState(null)
  const [selectRoom, setSelectRoom] = React.useState(false)
  const [selectedApplData, setSelectedApplData] = React.useState({
    data: { formData: [] },
  })
  const [ayModal, setAyModal] = React.useState(false)
  const [ayModalData, setAyModalData] = React.useState(null)

  const getData = useGetQuery({
    apiURL: isLocalEnvironment + '/getData',
    apiEndpoint: 'classSections',
    params: '',
    isDynamic: true,
  })
  const getOnchangeAppl = async (e, classSectionId, onLoad = false) => {
    let rVal = onLoad ? '&classSectionId=' + classSectionId : ''
    if (roomVal !== null && roomVal !== '') {
      rVal = '&classSectionId=' + roomVal
    } else {
      if (!onLoad) {
        console.log('')
        setSelectRoom(true)
        return
      }
    }
    await getCallMutation
      .mutateAsync({
        apiURL: isLocalEnvironment + '/getData',
        apiEndpoint: 'classAttendance',
        params: '&isRegistered=true&isStudents=true&promotions=true' + rVal,
        doPolling: false,
        isDynamic: true,
      })
      .then((resp) => {
        setSelectedApplData(resp.formData)
      })
  }

  const openAYModal = (data) => {
    setAyModalData(data)
    setAyModal(true)
  }

  const closeAYModal = () => {
    setAyModalData(null)
    setAyModal(false)
  }

  const isLayoutDark = sessionStorage.getItem('themeLayout')
    ? sessionStorage.getItem('themeLayout')
    : false

  if (getData.isLoading) {
    return (
      <div>
        <div
          id="status"
          className="trtui-align-items-center trtui-d-none trtui-d-md-block trtui-justify-content-center"
          style={{
            width: '40px',
            height: '40px',
            position: 'absolute',
            left: '50%',
            top: '50%',
            margin: '-20px 0 0 6.4rem',
          }}
        >
          <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
            <span className="trtui-visually-hidden">Loading...</span>
          </div>
        </div>
        <div
          id="status"
          className="trtui-align-items-center trtui-d-block trtui-d-md-none trtui-justify-content-center"
          style={{
            width: '40px',
            height: '40px',
            position: 'absolute',
            left: '20%',
            top: '50%',
            margin: '-20px 0 0 6.4rem',
          }}
        >
          <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
            <span className="trtui-visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    )
  }
  return (
    <React.Fragment key={isLayoutDark}>
      <div className="trtui-row">
        <div className="trtui-col-12">
          <div className="trtui-page-title-box trtui-d-sm-flex trtui-align-items-center trtui-justify-content-between">
            <h4 className="trtui-mb-sm-0">{routeData.pageTitle}</h4>
            <div className="trtui-row">
              <div key="room" className="trtui-col-md-8 trtui-has-validation">
                <select
                  className={`trtui-form-control trtui-mb-2 ${selectRoom && 'trtui-is-invalid'}`}
                  style={{
                    paddingRight: 'calc(1.5em + 1rem)',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right calc(0.375em + 0.25rem) center',
                    backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
                  }}
                  onChange={(e) => setRoomVal(e.target.value)}
                >
                  <option value={''}>Select Class</option>
                  {getData.data?.formData?.length > 0 &&
                    getData.data?.formData?.map((r, rInd) => (
                      <option
                        key={rInd}
                        value={r.classSectionId}
                        selected={roomVal === r.classSectionId ? true : false}
                      >
                        {r.classSectionName}
                      </option>
                    ))}
                </select>
                {selectRoom && <div className="trtui-invalid-feedback">Select Class</div>}
              </div>
              <div key="autoRefresh" className="trtui-col-md-4">
                <button
                  className={`trtui-btn trtui-btn-primary`}
                  type="button"
                  onClick={() => getOnchangeAppl('date')}
                >
                  <i className="ri-search-line" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {getCallMutation.isLoading ? (
        <div>
          <div
            id="status"
            className="trtui-align-items-center trtui-d-none trtui-d-md-block trtui-justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              position: 'absolute',
              left: '50%',
              top: '50%',
              margin: '-20px 0 0 6.4rem',
            }}
          >
            <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
              <span className="trtui-visually-hidden">Loading...</span>
            </div>
          </div>
          <div
            id="status"
            className="trtui-align-items-center trtui-d-block trtui-d-md-none trtui-justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              position: 'absolute',
              left: '20%',
              top: '50%',
              margin: '-20px 0 0 6.4rem',
            }}
          >
            <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
              <span className="trtui-visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="trtui-row">
            {selectedApplData.length > 0 ? (
              selectedApplData
                .sort((a, b) => a.studentName - b.studentName)
                .map((card, cardInd) => (
                  // <div key={cardInd}>{card.attendanceRegistration.studentName}</div>
                  <div key={cardInd} className="trtui-row">
                    <div className="trtui-col-12">
                      <div
                        className="trtui-card mb-0 trtui-pt-2 trtui-pb-2"
                        style={{ marginBottom: '1rem' }}
                      >
                        <div
                          className="trtui-card-body"
                          style={{ paddingBottom: 0, paddingTop: 0 }}
                        >
                          <div className="trtui-d-sm-flex trtui-align-items-center">
                            <div className="trtui-row" style={{ width: '100%' }}>
                              <div className="trtui-col-9">
                                <a href="#!">
                                  <h5 className="trtui-fs-16">{card.studentName}</h5>
                                </a>
                              </div>
                              <div className="trtui-col-3 trtui-d-flex trtui-mt-0 trtui-text-muted trtui-mx-auto">
                                <button
                                  type="button"
                                  className={`trtui-btn trtui-btn-sm trtui-btn-primary`}
                                  onClick={() => openAYModal(card)}
                                >
                                  AY Class
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
            ) : (
              <NoDataCard key={isLayoutDark} isLayoutDark={isLayoutDark} />
            )}
          </div>
          {ayModalData !== null && ayModal && (
            <ChildForm
              key={ayModalData}
              listKey={0}
              defaultData={ayModalData}
              parentData={ayModalData}
              modalSchema={modalSchema}
              childFormData={ayModalData.applicationAYClassSections}
              setChildFormData={setAyModalData}
              closeChildForm={closeAYModal}
              envData={envData}
              isLocalEnvironment={isLocalEnvironment}
            />
          )}
        </>
      )}
    </React.Fragment>
  )
}

ClassPromotions.propTypes = {
  isLocalEnvironment: PropTypes.string,
  envData: PropTypes.object,
  authDetails: PropTypes.object,
  routeData: PropTypes.object,
  modalSchema: PropTypes.object,
}
